(function() {
	rstools.vehicle.make = {
		utils: {
			getIDs: function (makes) {
				return $.map(makes, function (make) {
					return make.VehicleMakeID;
				});
			},

			getTitles: function (makes) {
				return $.map(makes, function (make) {
					return make.VehicleMakeName;
				});
			}
		}
	};
})();